import React from "react";
import { Seo } from "../lib/seo";
import { Section, Button } from "../components/ui";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404/" noindex description="Page not found" />
      <Section>
        <div className="py-16 text-center max-w-lg mx-auto">
          <div className="font-mono text-2xs uppercase tracking-eyebrow text-ink-400">404</div>
          <h1 className="mt-3 text-4xl text-ink-950">We couldn't find that page.</h1>
          <p className="mt-3 text-ink-600">It may have moved. Try the home page or the resources library.</p>
          <div className="mt-6 flex justify-center gap-3"><Button to="/" variant="primary" size="md">Home</Button><Button to="/resources/" variant="secondary" size="md">Resources</Button></div>
        </div>
      </Section>
    </>
  );
}
